module.exports = __webpack_public_path__ + "static/media/abhinav.ed4de8ad.jpg";